// Module
var code = `{{#content}}

<div class="code-container-properties-content__custom-items__custom-item">{{.}}</div>

{{/content}}
`;
// Exports
module.exports = code;